import React from "react";
import FormNewPassword from "./FormNewPassword/FormNewPassword";
import "./DefineNewPassword.css";

const DefineNewPassword = () => {
  return <FormNewPassword />;
};

export default DefineNewPassword;
